module.exports = __webpack_public_path__ + "static/media/40.40394598.wav";